function updateSavingsStyle() {
  const discount = document.querySelector('.cart__discounts');
  const savings = document.querySelector('.cart__savings');

  if (!discount || !savings) return;

  if (discount.classList.contains('hide')) {
    savings.classList.add('no-discount');
  } else {
    savings.classList.remove('no-discount');
  }
}


// Run initially
document.addEventListener('DOMContentLoaded', updateSavingsStyle);


// Run after cart updates (IMPORTANT)
document.addEventListener('cart:refresh', updateSavingsStyle);
document.addEventListener('cart:build', updateSavingsStyle);


// Fallback (covers all cases)
setInterval(updateSavingsStyle, 1000);